import React, { useMemo } from 'react';

import cn from 'classnames';

import { useChecklistContext } from '@features/Checklist/model/hooks';
import { Flex, Icon, UiButton, UiText, UITooltip } from '@shared/ui';

import cls from './ChecklistHeader.module.css';

export const ChecklistHeader = () => {
    const {
        checklistCounter,
        isCopied,
        isEditMode,
        rawChecklist,
        canModifyChecklist,
        onEditModeHandler,
        onCopyHandler,
        openDeletePopup,
    } = useChecklistContext();

    const validChecklist = useMemo(
        () => rawChecklist.filter((checklist) => checklist?.text?.length > 0),
        [rawChecklist]
    );
    const isValidChecklist = validChecklist.length > 0;

    return (
        <Flex as="header" fullWidth justify="between" className={cls.ChecklistHeader}>
            <UiText
                tag="h2"
                variant="subHeading"
                weight="bold"
                className={cls.ChecklistHeader}
                data-checklist-count={checklistCounter}
            >
                Чек-лист
            </UiText>
            <Flex gap={8}>
                {!isEditMode && canModifyChecklist && (
                    <UITooltip label="Редактировать чек-лист">
                        <UiButton
                            className={cn(cls.EditBtn)}
                            startIcon={
                                <Icon
                                    iconName="taskExecutorsEdit"
                                    fill="#818998"
                                    width={12}
                                    height={14}
                                />
                            }
                            onClick={onEditModeHandler}
                        />
                    </UITooltip>
                )}

                <UITooltip label="Копировать чек-лист">
                    <UiButton
                        disabled={!isValidChecklist || isCopied}
                        className={cn(cls.CopyBtn, isCopied && cls.isCopiedBtn)}
                        startIcon={
                            isCopied ? <Icon iconName="checked" /> : <Icon iconName="copy" />
                        }
                        onClick={onCopyHandler}
                    />
                </UITooltip>
                {isEditMode && (
                    <UITooltip label="Удалить чек-лист">
                        <UiButton
                            className={cn(cls.DeleteBtn)}
                            startIcon={
                                <Icon iconName="taskDelete" fill="#EC3030" width={12} height={14} />
                            }
                            onClick={openDeletePopup}
                        />
                    </UITooltip>
                )}
            </Flex>
        </Flex>
    );
};
